function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Reminder.css';
import React, { useRef, useState, useEffect, useMemo, createRef } from 'react';
import { createPortal } from 'react-dom';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';
import { Arabic } from 'flatpickr/dist/l10n/ar.js';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import { Finnish } from 'flatpickr/dist/l10n/fi.js';
import { German } from 'flatpickr/dist/l10n/de.js';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import { Norwegian } from 'flatpickr/dist/l10n/no.js';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Swedish } from 'flatpickr/dist/l10n/sv.js';
import { Mandarin } from 'flatpickr/dist/l10n/zh.js';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Italian } from 'flatpickr/dist/l10n/it.js';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import { Romanian } from 'flatpickr/dist/l10n/ro.js';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { Ukrainian } from 'flatpickr/dist/l10n/uk.js';
import { Turkish } from 'flatpickr/dist/l10n/tr.js';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { getColorByTheme, getPageThemeColors, get, getGlobalDictionaryTerm, canUseDOM } from '../../../utils';
/* import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium'; */

import { ReactComponent as ReminderIcon } from '../../../resources/icons/icon-reminder.svg';
import { ReactComponent as PlusIcon } from '../../../resources/icons/icon-plus-round.svg';
import { ReactComponent as MinusIcon } from '../../../resources/icons/icon-minus-round.svg';
import { ReactComponent as CloseConfirm } from '../../../resources/icons/close-tag.svg';
import { ReactComponent as IconChevronDown } from '../../../resources/icons/IconChevronDown.svg';
import { ReactComponent as IconEnvelope } from '../../../resources/icons/icon-envelope.svg';
/* import { ReactComponent as IconWhatsapp }from '../../../resources/icons/icon-whatsapp.svg'; */
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { BASE_SINGLE_SELECT_PROPS } from '../../../utils/constants';
import { differenceInDays } from 'date-fns';
import Recaptcha from '../../Login/components/Recaptcha';
const reactSelectSingleUiSettings = BASE_SINGLE_SELECT_PROPS;
const reminderInitialWizardState = {
  remindPanelVisible: false,
  showReminderDateVariants: false,
  showReminderDatePicker: false,
  loading: false,
  dateType: '',
  date: '',
  reminderMode: 'email',
  reminderDataEmail: '',
  reminderDataTextPhone: '',
  reminderDataCountryCode: '',
  emailFieldValid: false,
  phoneFieldValid: false,
  consentCheckBoxValue: false
};
const Reminder = _ref => {
  let {
    lang,
    event,
    countryItems = [],
    themeValues,
    hidableMode = true,
    modeFeatured = false,
    modeSlider = false,
    location,
    eventDetail,
    externalSuccessCallback,
    eventsAnalytics,
    params,
    reminderAccordionStateValue,
    setIsOpenReminderCalendarPicker,
    numberOfDaysBeforeEventEnd,
    numberOfDaysBeforeEventStart,
    setReminderAccordionState,
    isEventBlur = false,
    eventStarted,
    userProfile,
    isSharedCh = false
  } = _ref;
  const eventAnalyticsTitle = get(event, 'englishTitle', get(event, 'title'));
  const sitecoreContext = useSitecoreContext();
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const setReminderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderSetReminder') || 'Remind me';
  const setReminderConfirmLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderSuccessMessage') || 'Reminder Has Been Set';
  /* const editLabel: string = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEdit') || ''; */
  const selectDateLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderSelectDate') || 'Select Date test';
  const calendarHeaderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderCalendarHeader') || 'When should we remind you?';
  const chooseDateLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderChooseDate') || 'Choose date';
  const dayPriorLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderOneDayPrior') || '1 day prior test';
  const weekPriorLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderOneWeekPrior') || '1 week prior test';
  const setReminderIntroLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEventReminderText') || '"You have the option to set up a timely reminder for this item. An email will be sent to your inbox as a reminder"';
  /* const whatsAppLabel: string = getGlobalDictionaryTerm(sitecoreContext, 'ReminderWhatsApp') || ''; */
  const emailLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEmail') || 'Email';
  /* const updateLabel: string = getGlobalDictionaryTerm(sitecoreContext, 'ReminderUpdate') || ''; */
  const whatsAppPlaceholderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderWhatsAppPlaceholder') || '12345678';
  const emailPlaceholderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEmailPlaceholder') || 'Email address';
  const doneLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderDone') || 'Done';
  const clearAllLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderClearAll') || 'Clear all';
  const checkBoxLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderConsentBox') || '';
  const PrivacyNoticeLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderPrivacyNotice') || '';
  const recaptchErrorMessage = getGlobalDictionaryTerm(sitecoreContext, 'FieldErrorRequiredRecaptcha') || '';
  const fp = /*#__PURE__*/createRef();
  const [isVdsite, setIsVdsite] = useState(true);
  const [remindState, setRemindState] = useState(reminderInitialWizardState);
  const [confirmationsContainer, setConfirmationsContainer] = useState(null);
  const [showRemindConfirmationMessage, setShowRemindConfirmationMessage] = useState(false);
  const confirmReminderMessage = useRef(null);
  const [highLightEmail, setHighLightEmail] = useState(false);
  const clickedEmailRef = useRef(false);
  const [dropOpened, setDropOpened] = useState(false);
  const [highLightPhoneText, setHighLightPhoneText] = useState(false);
  const clickedPhoneTextRef = useRef(false);
  const [recaptchaError, setRecaptchaError] = useState('');
  const dropFocusStampRef = useRef(0);
  const [highLightDrop, setHighLightDrop] = useState(false);
  const [preselectedValue, setPreselectedValue] = useState({
    label: null,
    value: ''
  });
  const [dpSelectedDate, setDpSelectedDate] = useState(null);
  const pageThemeColors = useMemo(() => getPageThemeColors(isVdsite), [isVdsite]);
  const colorSettings = useMemo(() => {
    if (themeValues) {
      return {
        '--component-background-color': themeValues[0],
        '--component-color': themeValues[1]
      };
    }
    return {
      '--component-background-color': primaryPageThemeColor ? primaryPageThemeColor : pageThemeColors.primary,
      '--component-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : pageThemeColors.primary)
    };
  }, [themeValues, primaryPageThemeColor, pageThemeColors]);
  const [showDropDownOptionChooseDate, setShowDropDownOptionChooseDate] = useState(true);
  const recaptchaRef = useRef(null);
  const showReminderPanelHandler = event => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SetReminderOpenClickAnalytics'], params), `${eventAnalyticsTitle} : ${eventDetail ? 'event detail' : 'event listing'}`);
    setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
      remindPanelVisible: !remindState.remindPanelVisible,
      showReminderDatePicker: false
    }));
  };
  const handleEmailBlur = () => {
    clickedEmailRef.current = false;
    setHighLightEmail(false);
  };
  const handleEmailMousedown = () => {
    clickedEmailRef.current = true;
  };
  const handleEmailFocus = () => {
    if (!clickedEmailRef.current) {
      setHighLightEmail(true);
    }
  };
  const handleEmailInput = e => {
    const target = e.target;
    setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
      emailFieldValid: target.validity.valid,
      reminderDataEmail: target.value
    }));
  };
  const handlePhoneTextMousedown = () => {
    clickedPhoneTextRef.current = true;
  };
  const handlePhoneTextFocus = () => {
    if (!clickedPhoneTextRef.current) {
      setHighLightPhoneText(true);
    }
  };
  const handlePhoneTextBlur = () => {
    clickedPhoneTextRef.current = false;
    setHighLightPhoneText(false);
  };
  const handlePhoneTextInput = e => {
    const target = e.target;
    setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
      phoneFieldValid: target.validity.valid,
      reminderDataTextPhone: target.value
    }));
  };
  const handleDropMousedown = () => {
    if (Date.now() - dropFocusStampRef.current < 10) {
      setHighLightDrop(false);
    }
    setDropOpened(!dropOpened);
  };
  const handleDropTouchstart = e => {
    const dropListTouched = !!e.target.closest('.select-dropdown__menu');
    if (!dropListTouched) {
      setDropOpened(!dropOpened);
    }
  };
  const handleDropFocus = () => {
    dropFocusStampRef.current = Date.now();
    setHighLightDrop(true);
  };
  const handleDropBlur = () => {
    setDropOpened(false);
    setHighLightDrop(false);
  };
  const handleDropKeyDown = e => {
    if (e.which === 13 || e.which === 32) {
      setDropOpened(!dropOpened);
      if (!dropOpened) {
        e.preventDefault();
      }
    }
    if (e.which === 27) {
      setDropOpened(false);
    }
  };
  const handleDropChange = e => {
    setDropOpened(false);
    setHighLightDrop(false);
    setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
      reminderDataCountryCode: e.value
    }));
  };
  const rawCountryItems = useMemo(() => {
    const countryItemsList = [...countryItems];
    return countryItemsList.map((country, index) => {
      const flagUrl = get(country, 'flag.jss.value.src') || '';
      const flagAlt = get(country, 'flag.jss.value.alt') || '';
      const countryName = get(country, 'countryName.jss.value') || '';
      const countryCode = get(country, 'countryCode.jss.value') || '';
      const phoneCode = get(country, 'phoneCode.jss.value') || '';
      return {
        label: /*#__PURE__*/React.createElement("span", {
          className: "select-item"
        }, flagUrl && !!flagUrl.length && /*#__PURE__*/React.createElement("img", {
          alt: flagAlt,
          className: "select-item__image",
          src: `/${flagUrl}`
        }), ' ', /*#__PURE__*/React.createElement("span", {
          className: "select-item__text"
        }, phoneCode || '-')),
        listingLabel: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, countryName), " ", `(${phoneCode || '-'})`),
        value: phoneCode || `${index}-`,
        code: countryCode,
        countryName: countryName
      };
    });
  }, []);
  const renderEngineInput = () => {
    return {
      email: /*#__PURE__*/React.createElement("input", {
        pattern: ".+@.+\\..+",
        className: `mb-0 ${highLightEmail ? 'input-text-primary--focused' : ''}`,
        type: "email",
        placeholder: emailPlaceholderLabel,
        onMouseDown: handleEmailMousedown,
        onFocus: handleEmailFocus,
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SetEmailWhatsappReminderAnalytics'], params), [eventAnalyticsTitle, `${remindState.reminderMode} text field`]);
        },
        onBlur: handleEmailBlur,
        onChange: handleEmailInput,
        value: remindState.reminderDataEmail,
        required: true
      }),
      whatsapp: /*#__PURE__*/React.createElement("div", {
        className: `events__reminder-engine-whatsapp-wrapper ${dropOpened ? 'events__reminder-engine-whatsapp-wrapper--opened' : ''}`
      }, /*#__PURE__*/React.createElement("div", {
        className: "dropdown-wrapper",
        onMouseDown: handleDropMousedown,
        onTouchStart: handleDropTouchstart
      }, /*#__PURE__*/React.createElement(Select, _extends({}, reactSelectSingleUiSettings, {
        name: `code-for-event-${event.objectID}`,
        options: rawCountryItems,
        defaultValue: remindState.reminderDataCountryCode ? rawCountryItems.find(item => item.value === remindState.reminderDataCountryCode) : preselectedValue,
        className: `react-custom-select ${highLightDrop ? 'react-custom-select--outlined' : ''}`,
        onKeyDown: handleDropKeyDown,
        onFocus: handleDropFocus,
        onBlur: handleDropBlur,
        onChange: handleDropChange,
        menuIsOpen: dropOpened,
        "aria-label": event.title,
        "aria-labelledby": event.title,
        formatOptionLabel: (option, _ref2) => {
          let {
            context
          } = _ref2;
          return context === 'menu' ? option.listingLabel : option.label;
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "events__reminder-engine-whatsapp-spacer"
      }), /*#__PURE__*/React.createElement("input", {
        className: `mb-0 ${highLightPhoneText ? 'input-text-primary--focused' : ''}`,
        type: "number",
        placeholder: whatsAppPlaceholderLabel,
        maxLength: 20,
        onMouseDown: handlePhoneTextMousedown,
        onFocus: handlePhoneTextFocus,
        onBlur: handlePhoneTextBlur,
        onChange: handlePhoneTextInput,
        value: remindState.reminderDataTextPhone,
        required: true
      }))
    }[remindState.reminderMode];
  };
  const clearDatepicker = () => {
    setDpSelectedDate(null);
    if (fp && fp.current && fp.current.flatpickr) {
      fp.current.flatpickr.clear();
    }
  };
  const reminderSubmit = async () => {
    if (remindState.loading) return;
    setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
      loading: true
    }));
    const engineValues = {
      email: {
        Email: remindState.reminderDataEmail
      },
      whatsapp: {
        PhoneNumber: `${remindState.reminderDataCountryCode}${remindState.reminderDataTextPhone}`
      }
    };
    const oADStartDate = get(event, 'startDate');
    let startDateFormatted;
    /* Offer and deal listing/details page case */
    if (oADStartDate) {
      startDateFormatted = oADStartDate.split('T')[0];
    }
    /* Event details page case */
    if (eventDetail) {
      startDateFormatted = `${event.detailEventDateStart} ${remindersAvailability.eventStartTime}`;
    }
    /* Event listing page case */
    if (event.datesRange) {
      startDateFormatted = `${get(event, 'datesRange.from_formatted')} ${remindersAvailability.eventStartTime}`;
    }
    const data = {
      EventDefinitionKey: get(sitecoreContext, 'configuration.salesforce.reminderEventDefinitionKey') || 'APIEvent-925c5418-c937-6df5-6b25-9b1c54267510',
      FirstName: userProfile && userProfile.firstName,
      LastName: userProfile && userProfile.lastName,
      Country: cachedCookieCountry,
      InterestedIn: '',
      OptinEconomyAndTourism: 'true',
      OptinEsportsAndGames: 'true',
      EventImageURL: event.image,
      DateOfReminder: remindState.date,
      ReminderType: remindState.reminderMode,
      UserDomain: document && document.location && document.location.host,
      Source: '',
      EventId: event.objectID,
      EventTitle: event.title,
      EventDescription: event.introText || event.info,
      EventStartDate: startDateFormatted,
      EventTime: remindersAvailability.eventStartTime,
      EventLocation: location || (Array.isArray(event.location) ? event.location.join() : event.location),
      EventUrl: event.url,
      EventCategory: event.category && Array.isArray(event.category) ? event.category.join() : event.category,
      Language: lang.toUpperCase(),
      Consent: remindState.consentCheckBoxValue
    };
    let recaptchaToken;
    if (recaptchaRef.current) {
      recaptchaToken = await recaptchaRef.current.getRecaptchaToken();
    }
    if (!recaptchaToken) {
      setRecaptchaError(recaptchErrorMessage);
    } else {
      setRecaptchaError('');
    }
    const dataToSend = _objectSpread(_objectSpread(_objectSpread({}, data), engineValues[remindState.reminderMode]), {}, {
      grecaptcharesponse: recaptchaToken
    });
    const apiCallUrl = '/api/salesforceapi/setreminder';
    if (confirmReminderMessage.current !== null) {
      clearTimeout(confirmReminderMessage.current);
    }
    setShowRemindConfirmationMessage(false);
    setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
      loading: true,
      remindPanelVisible: false
    }));
    await fetch(apiCallUrl, {
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      method: 'POST',
      body: JSON.stringify(dataToSend)
    }).then(res => {
      if (res.status === 200) return res.text();
    }).then(response => {
      if (typeof response === 'string' && response === 'true') {
        const confirmMessages = confirmationsContainer && confirmationsContainer.querySelectorAll('.events__reminder-confirm');
        if (confirmMessages && confirmMessages.length) {
          confirmMessages.forEach(message => {
            message.style.display = 'none';
          });
        }
        setShowRemindConfirmationMessage(true);
        setRemindState(_objectSpread(_objectSpread({}, reminderInitialWizardState), {}, {
          reminderDataEmail: userProfile && userProfile.email,
          emailFieldValid: !!userProfile
        }));
        if (externalSuccessCallback) {
          externalSuccessCallback();
        }
        confirmReminderMessage.current = setTimeout(() => {
          setShowRemindConfirmationMessage(false);
        }, 5000);
      } else {
        console.error('SF request returned false');
        setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
          loading: false,
          remindPanelVisible: true
        }));
      }
    }).catch(e => {
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        loading: false,
        remindPanelVisible: true
      }));
      console.error(e);
    });
    const formattedDate = new Date(dataToSend.DateOfReminder).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).replace(/ /g, '-');
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SetReminderSumbitClickAnalytics'], params), [eventAnalyticsTitle, formattedDate, remindState.reminderMode]);
  };

  /* The object with available dates of reminders */
  const remindersAvailability = useMemo(() => {
    /*Start date for Event*/
    const getEventStartDate = fn => {
      /* Event details page case */
      if (eventDetail) {
        if (Object.keys(event).length) {
          /* eventStartDate = Date.parse(`${event.detailEventDateStart} ${event.detailEventTimeStart}`); */
          return Date.parse(`${event.detailEventDateStart} 00:00`);
        }
      }

      /* Event listing page case */
      if (event.eventNextAvailableDate || event.datesRange) {
        const nextAvDate = event.eventNextAvailableDate;
        if (nextAvDate) {
          const dateTSplitted = nextAvDate.split('T');
          return Date.parse(dateTSplitted[0]);
        } else {
          return event.datesRange && event.datesRange.from * 1000;
        }
      }
    };

    /*Start date for OfferAndDeal*/
    const getOADStartDate = fn => {
      return event.startDate_s * 1000;
    };
    setRemindState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      remindPanelVisible: false
    }));
    let eventStartDate;
    if (event.showRuleIsHide && event.showRuleShowStartDate_s) {
      eventStartDate = event.showRuleShowStartDate_s * 1000;
    } else {
      const eventType = event && event.type && event.type[0];
      eventStartDate = {
        Event: getEventStartDate(),
        'Offer And Deal': getOADStartDate()
      }[eventType] || 0;
    }
    const eventDetailEventDateStart = new Date(event.detailEventDateStart);
    const numberOfDaysBeforeEventStart = differenceInDays(new Date(), eventDetailEventDateStart);
    const eventStarted = numberOfDaysBeforeEventStart >= 0 ? true : false;
    const lastPossibleDateForOneReminder = new Date(eventStartDate);
    lastPossibleDateForOneReminder.setDate(new Date(eventStartDate).getDate() - 1);
    const lastPossibleDateForSevenReminder = new Date(eventStartDate);
    lastPossibleDateForSevenReminder.setDate(new Date(eventStartDate).getDate() - 7);
    const tomorrowMidnight = new Date().setUTCHours(24, 0, 0, 0);
    const reminder1Stamp = lastPossibleDateForOneReminder.getTime();
    const reminder7Stamp = lastPossibleDateForSevenReminder.getTime();
    const nowStamp = Date.now();
    const eventDateEndStamp = new Date(event.detailEventDateEnd).getTime();
    const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
    return {
      ability1: nowStamp < reminder1Stamp,
      ability7: nowStamp < reminder7Stamp,
      abilityDatePicker: nowStamp < reminder1Stamp,
      datePickerEnd: eventDetail && eventStarted ? eventDateEndStamp - oneDayInMilliseconds : reminder1Stamp,
      datePickerStart: tomorrowMidnight,
      eventActualStamp: eventStartDate,
      functionalityAvailable: nowStamp < reminder1Stamp,
      now: nowStamp,
      reminder1Stamp: reminder1Stamp,
      reminder7Stamp: reminder7Stamp,
      eventStartTime: event.detailEventTimeStart ? event.detailEventTimeStart.slice(0, 5) : '00:00'
    };
  }, [event, eventDetail]);

  /* Get default phonecode by cookie session */
  const cachedCookieCountry = useMemo(() => {
    let countryCode = 'AE';
    if (canUseDOM) {
      const countryNameCookie = document.cookie.split(';').find(item => item.indexOf('user_country_code') > -1);
      if (countryNameCookie) {
        const countryName = countryNameCookie.replace('user_country_code=', '').trim();
        countryCode = countryName !== 'undefined' ? countryName.replace(/\s/g, '') : '';
      }
      if (process.env.STORYBOOK_MODE) {
        countryCode = 'PK';
      }
    }
    return countryCode;
  }, []);
  useEffect(() => {
    if (canUseDOM) {
      const predefinedWizardValues = {};

      /* Get cookie country */
      const countryCode = cachedCookieCountry;
      const serverCountry = rawCountryItems.find(item => item.code === countryCode) || rawCountryItems[0] || {};
      predefinedWizardValues.reminderDataCountryCode = serverCountry.value;
      setPreselectedValue(serverCountry);

      /* Get default email, if user loggedin */
      const user = userProfile;
      if (user) {
        predefinedWizardValues.emailFieldValid = true;
        predefinedWizardValues.reminderDataEmail = user.email;
      }

      /* Set values */
      setRemindState(prevState => _objectSpread(_objectSpread({}, prevState), predefinedWizardValues));
    }
  }, [cachedCookieCountry, rawCountryItems, userProfile]);

  /* Clear timeout of confirmation message */
  useEffect(() => {
    return () => {
      if (confirmReminderMessage.current !== null) {
        clearTimeout(confirmReminderMessage.current);
      }
    };
  }, []);
  useEffect(() => {
    if (canUseDOM) {
      const confirmatioWrapper = document.getElementById('event-remind-confirmations-wrapper');
      if (confirmatioWrapper) setConfirmationsContainer(confirmatioWrapper);
    }
  }, []);

  /* Clear timeout of confirmation message */
  useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  useEffect(() => {
    if (canUseDOM && window.location.search) {
      const value = new URLSearchParams(window.location.search).get('reminder');
      const shouldShowDropDownOptionChooseDate = numberOfDaysBeforeEventEnd && typeof numberOfDaysBeforeEventEnd === 'number' && numberOfDaysBeforeEventEnd !== 2 || event.numberOfDaysBeforeEventEnd && event.numberOfDaysBeforeEventEnd !== 2 || value && value !== '2';
      setShowDropDownOptionChooseDate(shouldShowDropDownOptionChooseDate);
    }
  }, [numberOfDaysBeforeEventEnd, event.numberOfDaysBeforeEventEnd]);
  useEffect(() => {
    if (reminderAccordionStateValue === 'email') setRemindState(reminderInitialWizardState);
  }, [reminderAccordionStateValue]);
  const currentLocale = useMemo(() => {
    const langHash = {
      ar: Arabic,
      ru: Russian,
      cs: Czech,
      nl: Dutch,
      fi: Finnish,
      de: German,
      ja: Japanese,
      no: Norwegian,
      pt: Portuguese,
      sv: Swedish,
      zh: Mandarin,
      da: Danish,
      fr: French,
      it: Italian,
      ko: Korean,
      pl: Polish,
      ro: Romanian,
      es: Spanish,
      uk: Ukrainian,
      tr: Turkish
    };
    return langHash[lang];
  }, [lang]);
  const reminderSubmitDisabled = !remindState.date || !(remindState.reminderMode === 'whatsapp' && remindState.phoneFieldValid || remindState.reminderMode === 'email' && remindState.emailFieldValid);
  return /*#__PURE__*/React.createElement("div", {
    style: colorSettings,
    className: `
      date-selector__picker
      ${dpCommonStyles}
      ${rtl ? dpRtlStyles : dpLtrStyles}
      ${commonStyles}
      ${rtl ? rtlStyles : ltrStyles}
    `
  }, /*#__PURE__*/React.createElement("div", {
    className: `events__reminder-item ${remindState.showReminderDatePicker ? 'events__reminder-item-fix' : ''} 
          ${isSharedCh ? 'events__reminder-item--shared' : ''}`
  }, hidableMode && /*#__PURE__*/React.createElement("button", {
    className: `
            events__reminder-cta btn--reset
            ${remindState.remindPanelVisible ? 'events__reminder-cta--hidden' : ''}
            ${modeFeatured ? 'events__reminder-cta--desk-visible' : ''}
            ${!modeSlider ? 'events__reminder-cta--desk-visible' : ''}

          `,
    onClick: () => {
      if (!isEventBlur && (typeof numberOfDaysBeforeEventEnd === 'number' && (numberOfDaysBeforeEventEnd === 1 || numberOfDaysBeforeEventEnd === 2) || eventStarted || typeof numberOfDaysBeforeEventStart === 'number' && (numberOfDaysBeforeEventStart === 1 || numberOfDaysBeforeEventStart === 2))) {
        window.location.href = `${event.url}${numberOfDaysBeforeEventEnd === 1 || numberOfDaysBeforeEventStart === 1 ? '?reminder=1' : '?reminder=2'}${eventStarted ? '&eventstarted=true' : ''}`;
        setReminderAccordionState && (numberOfDaysBeforeEventEnd === 1 || event.numberOfDaysBeforeEventEnd === 1) && setReminderAccordionState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
          isEmailBlockHidden: true
        }));
      } else {
        showReminderPanelHandler(event);
        setReminderAccordionState && setReminderAccordionState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
          isEmailBlockHidden: false
        }));
      }
    },
    disabled: isEventBlur ? remindState.loading || !remindersAvailability.ability1 : remindState.loading || event.numberOfDaysBeforeEventEnd <= 0 || typeof numberOfDaysBeforeEventEnd === 'number' && numberOfDaysBeforeEventEnd <= 0 || typeof numberOfDaysBeforeEventEnd === 'string' && numberOfDaysBeforeEventEnd === 'datesRange is not provided'
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ReminderIcon, {
    className: "icon-calendar"
  }), " ", setReminderLabel), /*#__PURE__*/React.createElement("span", {
    className: "events__reminder-close-opened"
  }, /*#__PURE__*/React.createElement(PlusIcon, {
    className: "icon-inerraction"
  }))), (remindState.remindPanelVisible || !hidableMode) && /*#__PURE__*/React.createElement("div", {
    className: `
            events__reminder-panel
            ${eventDetail ? 'events__reminder-panel--detailviewed' : ''}
            ${modeFeatured ? 'events__reminder-panel--positioned' : ''}
            ${!modeSlider ? 'events__reminder-panel--positioned' : ''}
            ${!hidableMode && remindState.showReminderDatePicker ? 'events__reminder-panel--height-reserved' : ''}
          `
  }, hidableMode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-cta"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ReminderIcon, {
    className: "icon-calendar"
  }), " ", setReminderLabel), /*#__PURE__*/React.createElement("button", {
    className: "events__reminder-close-opened btn--reset",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SetReminderCloseClickAnalytics'], params), eventAnalyticsTitle);
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        remindPanelVisible: !remindState.remindPanelVisible
      }));
    }
  }, /*#__PURE__*/React.createElement(MinusIcon, {
    className: "icon-inerraction"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-intro"
  }, setReminderIntroLabel)), remindState.showReminderDatePicker === false && /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-steps-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: `events__reminder-dd-wrapper ${remindState.showReminderDateVariants ? 'events__reminder-dd-wrapper--opened' : ''}`
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn--reset events__reminder-dd-btn",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SelectReminderDateAnalytics'], params), [get(event, 'englishTitle', get(event, 'title')), remindState.showReminderDateVariants ? 'close' : 'open']);
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        dateType: reminderInitialWizardState.dateType,
        date: reminderInitialWizardState.date,
        showReminderDateVariants: !remindState.showReminderDateVariants
      }));
    }
  }, remindState.dateType || selectDateLabel, " ", /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })), remindState.showReminderDateVariants && /*#__PURE__*/React.createElement("ul", {
    className: "events__reminder-dd-variants-list"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      const dateString = new Date(remindersAvailability.reminder1Stamp).toLocaleDateString('en-CA');
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        dateType: dayPriorLabel,
        /* date: `${dateString} ${remindersAvailability.eventStartTime}`, */
        date: `${dateString} 00:00`,
        showReminderDateVariants: false,
        showReminderDatePicker: false
      }));
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SelectReminderDateOptionAnalytics'], params), [eventAnalyticsTitle, dayPriorLabel]);
      setIsOpenReminderCalendarPicker && setIsOpenReminderCalendarPicker(false);
    },
    className: "events__reminder-dd-variant btn--reset"
  }, dayPriorLabel)), (isEventBlur ? remindersAvailability.ability7 : typeof numberOfDaysBeforeEventEnd === 'number' && numberOfDaysBeforeEventEnd > 7 || event.numberOfDaysBeforeEventEnd > 7) && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SelectReminderDateOptionAnalytics'], params), [eventAnalyticsTitle, weekPriorLabel]);
      const dateString = new Date(remindersAvailability.reminder7Stamp).toLocaleDateString('en-CA');
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        dateType: weekPriorLabel,
        /* date: `${dateString} ${remindersAvailability.eventStartTime}`, */
        date: `${dateString} 00:00`,
        showReminderDateVariants: false,
        showReminderDatePicker: false
      }));
      setIsOpenReminderCalendarPicker && setIsOpenReminderCalendarPicker(false);
    },
    className: "events__reminder-dd-variant btn--reset"
  }, weekPriorLabel)), showDropDownOptionChooseDate && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SelectReminderDateOptionAnalytics'], params), [eventAnalyticsTitle, chooseDateLabel]);
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        showReminderDateVariants: false,
        showReminderDatePicker: true
      }));
      setIsOpenReminderCalendarPicker && setIsOpenReminderCalendarPicker(true);
    },
    className: "events__reminder-dd-variant btn--reset"
  }, chooseDateLabel)))), remindState.date && !remindState.showReminderDateVariants && /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-engine-selector"
  }, /*#__PURE__*/React.createElement("button", {
    className: `events__reminder-engine-selector-cta btn--reset ${remindState.reminderMode === 'email' ? 'events__reminder-engine-selector-cta--active' : ''}`,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SetEmailWhatsappReminderAnalytics'], params), [eventAnalyticsTitle, 'email click']);
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        reminderMode: 'email'
      }));
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "events__reminder-engine-selector-cta-text"
  }, /*#__PURE__*/React.createElement(IconEnvelope, {
    className: "icon"
  }), emailLabel))), remindState.date && !remindState.showReminderDateVariants && /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-engine-data"
  }, renderEngineInput()), remindState.date && /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-checkbox-wrapper"
  }, /*#__PURE__*/React.createElement("label", {
    className: "events__reminder-checkbox-label"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    name: "receive-events-updates",
    onChange: e => {
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        consentCheckBoxValue: e.target.checked
      }));
    }
  }), /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    field: {
      value: checkBoxLabel
    }
  }))), !remindState.showReminderDateVariants && /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-submit-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: reminderSubmit,
    disabled: reminderSubmitDisabled || remindState.loading
  }, setReminderLabel), /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "events-reminder-privacy-notice",
    field: {
      value: PrivacyNoticeLabel
    }
  }))), remindState.showReminderDatePicker && /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-dp-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-dp-border"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-dp-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link btn-close-calendar",
    onClick: () => {
      setIsOpenReminderCalendarPicker && setIsOpenReminderCalendarPicker(false);
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        showReminderDatePicker: false
      }));
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "15",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.288,1.37329a2.137,2.137 0 0 0 0.285,2.925l2.436,2.116l-14.009,0l0,1.916l14.009,0l-2.436,2.117a2.137,2.137 0 0 0 -0.285,2.926l6.712,-6l-6.712,-6z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("h5", {
    className: "events__reminder-dp-title"
  }, calendarHeaderLabel), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link",
    onClick: clearDatepicker
  }, clearAllLabel)), /*#__PURE__*/React.createElement(Flatpickr, {
    ref: fp,
    "aria-label": calendarHeaderLabel,
    options: {
      showMonths: 1,
      allowInput: false,
      mode: 'single',
      minDate: remindersAvailability.datePickerStart,
      maxDate: remindersAvailability.datePickerEnd,
      inline: true,
      locale: lang === 'en' ? 'en' : currentLocale,
      nextArrow: `<svg width="20" height="15" viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg"><path d="m12.288,1.37329a2.137,2.137 0 0 0 0.285,2.925l2.436,2.116l-14.009,0l0,1.916l14.009,0l-2.436,2.117a2.137,2.137 0 0 0 -0.285,2.926l6.712,-6l-6.712,-6z" fill="currentColor"/></svg>`,
      prevArrow: `<svg width="20" height="15" viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg"><path d="m12.288,1.37329a2.137,2.137 0 0 0 0.285,2.925l2.436,2.116l-14.009,0l0,1.916l14.009,0l-2.436,2.117a2.137,2.137 0 0 0 -0.285,2.926l6.712,-6l-6.712,-6z" fill="currentColor"/></svg>`
    },
    onChange: date => {
      if (date && date.length !== 0) {
        setDpSelectedDate(date[0]);
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-dp-cta"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    disabled: !dpSelectedDate,
    onClick: () => {
      if (dpSelectedDate) {
        const formattedDate = dpSelectedDate.toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        });
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SelectReminderDateValueAnalytics'], params), [eventAnalyticsTitle, formattedDate.replace(/ /g, '-')]);
      }
      const typeMonth = dpSelectedDate ? dpSelectedDate.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short'
      }) : '';
      clearDatepicker();
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        dateType: typeMonth,
        date: dpSelectedDate ? `${dpSelectedDate.toLocaleDateString('en-CA')} 00:00` : '',
        showReminderDateVariants: false,
        showReminderDatePicker: false
      }));
    }
  }, doneLabel)))), showRemindConfirmationMessage && confirmationsContainer ? /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("div", {
    className: "events__reminder-confirm",
    title: event.title
  }, setReminderConfirmLabel, /*#__PURE__*/React.createElement("button", {
    className: "events__reminder-confirm-close btn--reset",
    onClick: () => {
      if (confirmReminderMessage.current !== null) {
        clearTimeout(confirmReminderMessage.current);
      }
      setShowRemindConfirmationMessage(false);
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['CloseNotificationClickAnalytics'], params), [eventAnalyticsTitle, setReminderConfirmLabel]);
    }
  }, /*#__PURE__*/React.createElement(CloseConfirm, {
    className: "icon"
  }))), confirmationsContainer) : null), /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaError,
    ref: recaptchaRef
  }));
};
const dpCommonStyles = "dqvuxp6";
const dpRtlStyles = "d77sl8t";
const dpLtrStyles = "d14n39i4";
const commonStyles = "cib6kfb";
const ltrStyles = "l9o4w1x";
const rtlStyles = "r5stag7";
export default Reminder;